import React, { useEffect, useState } from 'react';
import {
  Button,
  IconButton,
  Modal,
  Table,
  Tooltip,
  Whisper,
  Pagination,
  InputGroup,
  Input,
  Stack,
  Checkbox,
  Dropdown
} from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
import CloudReflashIcon from '@rsuite/icons/CloudReflash';
import globalIP from '@/GlobelIP';
import useLabel from '@/clientWeb/hook/Label';
import SearchIcon from '@rsuite/icons/Search';
const { Column, HeaderCell, Cell } = Table;
const RecyleProduct = ({
  reopen,
  handleReClose,
  data,
  fetchDatat,
  tableMeta,
  page,
  setPage,
  handleChangeLimit,
  searchQuery1,
  setSearchQuery1,
  fetchData
}) => {
  console.log(data, tableMeta)
  const { attributesName } = useLabel();
  const [auth, setAuth] = useState(false);
  const [selectedItems, setSelectedItems] = useState([])
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      setAuth(json.data[0].attributes.Authorised);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleRestoreRow = async Id => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...data,
        // Authorized: auth == true ? 'Authorised' :'Pending'
        Authorized: auth == true ? 'Pending' : 'Authorised'
      })
    );
    fetch(`${globalIP}/api/products/${Id}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchDatat();
        fetchData();
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleDeleteRow = async Id => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        Authorized: 'Remove',
        ProductId: null,
        ProductName: null,
        MadeBy: null,
        HSNCode: null,
        BuyerName: null,
        BuyerSku: null
      })
    );
    fetch(`${globalIP}/api/products/${Id}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchDatat();
        fetchData();
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleCheckAll = (param1, param2) => {
    let checked = param1?.target ? param1.target.checked : param2;

    if (!checked) {
      setSelectedItems([]);
      return;
    }

    // Use table's current data
    const allIds = data.map(item => item.id);
    setSelectedItems(allIds);
  };

  const handleRestoreSelected = async () => {
    if (selectedItems.length === 0) return;

    try {
      await Promise.all(
        selectedItems.map(async (id) => {
          const formData = new FormData();
          formData.append(
            "data",
            JSON.stringify({
              ...data,
              Authorized: auth === true ? "Pending" : "Authorised"
            })
          );

          return fetch(`${globalIP}/api/products/${id}`, {
            method: "PUT",
            body: formData
          });
        })
      );

      // Refresh table after all updates complete
      await fetchDatat();
      await fetchData();

      setSelectedItems([]); // Clear selection
    } catch (error) {
      console.error("Restore error:", error);
    }
  };
  const handleDeleteSelected = async () => {
    if (selectedItems.length === 0) return;

    try {
      await Promise.all(
        selectedItems.map(async (id) => {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              Authorized: 'Remove',
              ProductId: null,
              ProductName: null,
              MadeBy: null,
              HSNCode: null,
              BuyerName: null,
              BuyerSku: null
            })
          );

          return fetch(`${globalIP}/api/products/${id}`, {
            method: "PUT",
            body: formData
          });
        })
      );

      // Refresh table after all updates complete
      await fetchDatat();
      await fetchData();

      setSelectedItems([]); // Clear selection
    } catch (error) {
      console.error("Restore error:", error);
    }
  };

  return (
    <Modal open={reopen} onClose={handleReClose} size="full" backdrop="static">
      <Modal.Header>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            paddingRight: "8px",
          }}
        >
          <Modal.Title>Trash Products</Modal.Title>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Dropdown title="Bulk Action" placement="bottomEnd">
              <Dropdown.Item
                icon={<CloudReflashIcon />}
                onClick={handleRestoreSelected}
                disabled={selectedItems.length === 0}
              >
                Restore Selected
              </Dropdown.Item>
              <Dropdown.Item
                icon={<TrashIcon style={{ fontSize: 15, color: selectedItems.length !== 0 && 'red' }} />}
                onClick={handleDeleteSelected}
                disabled={selectedItems.length === 0}
              >
                Delete Selected
              </Dropdown.Item>
            </Dropdown>

            <InputGroup inside>
              <Input
                placeholder="Search"
                value={searchQuery1}
                onChange={setSearchQuery1}
                className="pdt-srch"
              />
              <InputGroup.Addon>
                <SearchIcon style={{ cursor: "pointer" }} />
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <Table height={420} data={data} bordered cellBordered>
          <Table.Column width={80} align="center" fixed>
            <HeaderCell>
              <Checkbox
                indeterminate={
                  selectedItems.length > 0 &&
                  selectedItems.length < data.length
                }
                checked={
                  selectedItems.length > 0 &&
                  selectedItems.length === data.length
                }
                onChange={handleCheckAll}
              />
            </HeaderCell>

            <Table.Cell>
              {rowData => (
                <Checkbox
                  checked={selectedItems.includes(rowData.id)}
                  onChange={(value, checked) => {
                    if (checked) {
                      setSelectedItems(prev => [...prev, rowData.id]);
                    } else {
                      setSelectedItems(prev => prev.filter(id => id !== rowData.id));
                    }
                  }}
                />
              )}
            </Table.Cell>
          </Table.Column>

          <Table.Column width={80} align="center" fixed>
            <HeaderCell>
              <b>Sr. No.</b>
            </HeaderCell>
            <Cell>{(_, rowIndex) => (page - 1) * 25 + rowIndex + 1}</Cell>
          </Table.Column>
          <Table.Column width={120} align="center">
            <HeaderCell>
              <b>Image</b>
            </HeaderCell>
            <Table.Cell>
              {rowData => {
                const imageUrl = `${globalIP}${rowData.attributes?.CoverImage?.data?.attributes?.url}`;

                const renderTooltip = imageSrc => (
                  <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                    <img
                      src={imageSrc}
                      alt="Product Image"
                      style={{ width: 400, height: 400, objectFit: 'contain' }}
                    />
                  </Tooltip>
                );

                return (
                  <Whisper trigger="hover" placement="right" speaker={renderTooltip(imageUrl)}>
                    <img
                      src={imageUrl}
                      alt="Product Image"
                      style={{
                        width: 50,
                        height: 50,
                        objectFit: 'contain',
                        marginTop: '-16px',
                        border: '1px solid #ddd',
                        borderRadius: 4
                      }}
                    />
                  </Whisper>
                );
              }}
            </Table.Cell>
          </Table.Column>

          <Column width={300} align="center">
            <HeaderCell>
              <b>{attributesName?.ProductName}</b>
            </HeaderCell>
            <Cell dataKey={'attributes.ProductName'} />
          </Column>
          <Column width={200} align="center">
            <HeaderCell>
              <b>{attributesName?.AliasCode}</b>
            </HeaderCell>
            <Cell dataKey={'attributes.ProductId'} />
          </Column>

          <Column width={200} align="center">
            <HeaderCell>
              <b>{attributesName?.Category}</b>
            </HeaderCell>
            <Cell dataKey={'attributes.CategoryName'} />
          </Column>
          <Column width={250} align="center">
            <HeaderCell>
              <b>Action</b>
            </HeaderCell>
            <Table.Cell>
              {rowData => (
                <>
                  <Whisper followCursor speaker={<Tooltip>Restore</Tooltip>}>
                    <IconButton
                      size="xs"
                      icon={<CloudReflashIcon />}
                      active
                      style={{ marginRight: '10px' }}
                      onClick={() => handleRestoreRow(rowData.id)}
                    />
                  </Whisper>
                  <Whisper followCursor speaker={<Tooltip>Delete</Tooltip>}>
                    <IconButton
                      size="xs"
                      icon={<TrashIcon style={{ fontSize: '15px', color: "red" }} />} // delete ka icon
                      color="red"            // red color delete ke liye
                      style={{ marginRight: '10px', }}
                      onClick={() => handleDeleteRow(rowData.id)}  // delete function call
                    />
                  </Whisper>
                  {/* <Whisper followCursor speaker={<Tooltip>Delete</Tooltip>}>
                    <IconButton
                      size="xs"
                      icon={<TrashIcon />}
                      active
                      style={{ marginRight: '10px' }}
                      //   onClick={() => handleDeleteRow(rowData.id)}
                    />
                  </Whisper> */}
                </>
              )}
            </Table.Cell>
          </Column>
          <Column width={100}>
            <HeaderCell>
              <b>Status</b>
            </HeaderCell>
            <Cell dataKey={'attributes.Authorized'}>
              {rowData => (
                <Button
                  size='sm'
                  style={{
                    width: '58px',
                    height: '30px',
                    borderRadius: '6px',
                    color: 'white',
                    backgroundColor: 'red'
                  }}
                >
                  {rowData.attributes.Authorized}
                </Button>
              )}
            </Cell>
          </Column>
        </Table>
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            limit={25}
            layout={['total', '-', 'pager', 'skip']}
            total={tableMeta?.pagination?.total || 0}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleReClose} appearance="primary" color="cyan">
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecyleProduct;
